export default "__VITE_ASSET__yXPbtqdf__"